<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'GridTable',
})
</script>
<template>
  <VxeGrid ref="xGrid" v-bind="gridOptions" v-on="gridEvent || {}">
    <template #[item]="_props" v-for="item in Object.keys($slots)" :key="item">
      <slot :name="item" v-bind="_props || {}"></slot>
    </template>
  </VxeGrid>
</template>
<script lang="ts" setup name="GridTable">
import { ref, inject, onMounted } from 'vue'
import { VxeGrid, VxeGridProps, VxeGridListeners } from 'vxe-table'

interface props {
  uid: Symbol
  gridOptions: VxeGridProps
  gridEvent?: VxeGridListeners
}
const props = defineProps<props>()
const xGrid = ref()
const table = inject(props.uid)

onMounted(() => {
  // @ts-ignore
  table?.setTable({
    tableRef: xGrid.value,
  })
})
</script>
<style>
/* 阻止滚动链接，滚动不会传播给祖先 */
.vxe-table--body-wrapper {
  overscroll-behavior: contain;
}
</style>
